import { render, staticRenderFns } from "./ybs_index.vue?vue&type=template&id=21f527b0&scoped=true&"
import script from "./ybs_index.vue?vue&type=script&lang=js&"
export * from "./ybs_index.vue?vue&type=script&lang=js&"
import style0 from "./ybs_index.vue?vue&type=style&index=0&id=21f527b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f527b0",
  null
  
)

export default component.exports